import React, { Component } from "react";
import CssClasses from "./QRCodes.css";
import QRCode from "qrcode.react";

import { connect } from "react-redux";

import * as UserPermissionIDs from "../../../HOCs/Constants/UserPermissionIDs";

class QRCodes extends Component {
  qrCodeTypes = [
    { id: 1, title: "PRIJAVA ADMINA" },
    { id: 2, title: "OTVARANJE VRATA" },
    { id: 3, title: "GAŠENJE UREĐAJA" },
    { id: 4, title: "RESTART UREĐAJA" }
  ];

  state = {
    currentQrCode: 1
  };

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.contentBox}>
          <div className={CssClasses.boxBtnPickers}>
            {this.qrCodeTypes.map(info => {
              if (
                this.props.adminInfo.PermissionList &&
                !this.props.adminInfo.PermissionList.includes(
                  this.getPermissionIDForButtonID(info.id)
                )
              ) {
                return null;
              }

              return (
                <button
                  key={info.id}
                  className={[
                    CssClasses.chooseCodeBtn,
                    this.state.currentQrCode === info.id
                      ? CssClasses.activeBtn
                      : ""
                  ].join(" ")}
                  onClick={() => this.btnCodeType_Click(info.id)}
                >
                  {info.title}
                </button>
              );
            })}
          </div>
          <div className={CssClasses.boxRightSection}>
            <div className={CssClasses.boxQrSection}>
              {this.state.currentQrCode > 0 ? (
                <QRCode value={this.getQrCodeValue()} size={200} />
              ) : null}
            </div>
            <div className={CssClasses.boxPrintBtn}>
              {this.state.currentQrCode > 0 ? (
                <button
                  className={CssClasses.printCodeBtn}
                  onClick={() => this.btnPrintCode_Click()}
                >
                  ISPIŠI QR KOD
                </button>
              ) : null}
            </div>
          </div>
          <div className={CssClasses.clearFix} />
        </div>
      </div>
    );
  }

  getPermissionIDForButtonID = btnID => {
    switch (btnID) {
      case 1:
        return UserPermissionIDs.ADMIN_ACTION_LOGIN;
      case 2:
        return UserPermissionIDs.ADMIN_ACTION_OPEN_DRAWER;
      case 3:
        return UserPermissionIDs.ADMIN_ACTION_SHUT_DOWN;
      case 4:
        return UserPermissionIDs.ADMIN_ACTION_RESTART;
      default:
        return 0;
    }
  };

  getQrCodeValue() {
    switch (this.state.currentQrCode) {
      case 1:
        return "ADMIN-CMD-LOGIN-" + this.props.adminInfo.UserToken;
      case 2:
        return "ADMIN-CMD-OPEN-DRAWER-" + this.props.adminInfo.UserToken;
      case 3:
        return "ADMIN-CMD-SHUTDOWN-" + this.props.adminInfo.UserToken;
      case 4:
        return "ADMIN-CMD-RESTART-" + this.props.adminInfo.UserToken;
      default:
        return "unknown";
    }
  }

  btnCodeType_Click(id) {
    this.setState({ currentQrCode: id });
  }

  btnPrintCode_Click() {
    switch (this.state.currentQrCode) {
      case 1: //login
        window.cefCustomObject.printAdminQRLogin(
          this.props.adminInfo.UserToken
        );
        break;
      case 2: //draer
        window.cefCustomObject.printAdminQROpenDrawer(
          this.props.adminInfo.UserToken
        );
        break;
      case 3: //shutdown
        window.cefCustomObject.printAdminQRShutdown(
          this.props.adminInfo.UserToken
        );
        break;
      case 4: //restart
        window.cefCustomObject.printAdminQRRestart(
          this.props.adminInfo.UserToken
        );
        break;
      default:
        break;
    }
  }
}

const mapStateToProps = state => {
  return {
    adminInfo: state.rrNavigation.adminInfo
  };
};

export default connect(mapStateToProps)(QRCodes);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/QRCodes/QRCodes.js